import type { ProductAd } from '@/scopes/product-ads/domain/types'

import { ProductAdLoading } from '@/scopes/product-ads/components/ProductAdLoading'
import { mqMin, space } from '@sunwebgroup/ui-components'
import useEmblaCarousel from 'embla-carousel-react'
import { styled } from 'styled-components'
import { ProductAdComponent } from './ProductAd'

const Slider = styled.div`
  overflow: hidden;
`

const Wrapper = styled.div`
  display: flex;
  gap: ${space('primitives_space_16')};
  padding: ${space('primitives_space_4')};
  // needed to show the shadow of the items
  @media ${mqMin('primitives_breakpoint_l_min')} {
    width: 500px;
  }
`

interface ProductAdsListProps {
  data: ProductAd[]
  isLoading?: boolean
  type: string
}

export function ProductAdsList({ data, isLoading, type }: ProductAdsListProps) {
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
  })

  const adsLoadings = []
  for (let i = 0; i < 5; i++) {
    adsLoadings.push(
      <ProductAdLoading />,
    )
  }

  if (isLoading) {
    return (
      <Slider>
        <Wrapper>{adsLoadings}</Wrapper>
      </Slider>
    )
  }

  return (
    <Slider ref={emblaRef}>
      <Wrapper>
        {data.map(productAd => (
          <ProductAdComponent data={productAd} key={productAd.adId} componentType={type} />
        ))}
      </Wrapper>
    </Slider>
  )
}
